import { Database } from "../../../../features/Database";
import { DatabasePage } from "../../../../pages/DatabasePage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const databasePageRouteConfig: AppRouteProps = {
  path: appRouterPaths.knowledge_base.root,
  element: <DatabasePage />,
  name: "База знаний",
  children: appRouterPaths.knowledge_base.item
    ? [
        {
          path: appRouterPaths.knowledge_base.item,
          element: <Database />,
          name: "Векторное хранилище",
        },
      ]
    : undefined,
};
